import { format } from 'date-fns';
import { parseIsoDate } from './parse-iso-date';

export function formatFieldDateLabel(value: string): string {
  const parsed = parseIsoDate(value);
  if (!parsed) return value || 'Pick a date';
  return format(parsed, 'PPP');
}
